export const ADMIN = 'ROLE_ADMIN'
export const USER = 'ROLE_USER'

export const ROLES = {
  ADMIN,
  USER,
}
